module.exports = "https://bin.bnbstatic.com/_next/static/images/es4-599fb92d65da2feca768b2e5621466d9.jpg";